export const REDUCER_NAME = 'crm';

export interface ITelecaller {
  id: string; name: string; phone: string; email: string;
  daily_target: number; is_active: number; created_at: string;
  active_leads?: number;
}

export interface ICRMLead {
  id: string; vendorId: string; name: string; phone: string; email?: string;
  source: string;
  status: string;
  assigned_to?: string; assigned_name?: string;
  created_at: string; updated_at?: string; last_called_at?: string; next_followup_at?: string;
  notes?: string; call_attempts: number; is_overdue?: boolean;
  whatsapp_sent?: number; whatsapp_sent_at?: string;
  whatsapp_opted_out?: number; whatsapp_opted_out_at?: string;
  tags?: ICRMTag[];
  score?: number;
}

export interface ICRMStatus {
  id: string; vendorId: string; key: string; label: string; color: string;
  sort_order: number; is_system: number; created_at: string;
}

export interface ICRMTag {
  id: string; vendorId: string; name: string; color: string; created_at: string;
}

export interface ICRMWhatsAppTemplate {
  id: string; vendorId: string; name?: string | null;
  source: string; trigger_event: string; template_text: string;
  is_default: number; updated_at?: string;
}

export interface ICallLog {
  id: string; lead_id: string; telecaller_id: string; telecaller_name?: string;
  called_at: string; duration_seconds: number; status_after_call: string;
  notes?: string; next_followup_at?: string;
}

export interface IFollowup {
  id: string; lead_id: string; lead_name?: string; lead_phone?: string;
  telecaller_id: string; telecaller_name?: string;
  scheduled_at: string; completed: number; notes?: string;
}

export interface ILeadTimelineEntry {
  id: string; created_at: string; telecaller_name?: string;
  source: 'activity' | 'call' | 'whatsapp';
  activity_type: 'STATUS_CHANGE' | 'NOTE_UPDATE' | 'ASSIGNED' | 'CALL_LOGGED' | 'WHATSAPP_SENT';
  old_value?: string | null; new_value?: string | null;
  duration_seconds?: number; status_after_call?: string; notes?: string; has_recording?: number | boolean;
  message?: string; status?: 'sent' | 'failed'; error?: string | null;
}

export interface ICRMState {
  leads: ICRMLead[]; total: number; isLoading: boolean;
  telecallers: ITelecaller[]; telecallersLoading: boolean;
  statuses: ICRMStatus[]; tags: ICRMTag[];
  adminDashboard: any; telecallerDashboard: any;
  followups: IFollowup[]; callLogs: ICallLog[];
  timeline: ILeadTimelineEntry[]; timelineLoading: boolean;
  errorMessage: string | null;
}
